import React from 'react';
import { useCanvasStore, Board } from '@/stores/canvasStore';
import { getFolderColorFromValue } from '@/lib/folderColors';

// macOS-style folder path - tab on left side with rounded corners
const FOLDER_PATH = "M8 4 Q4 4 4 8 L4 82 Q4 86 8 86 L112 86 Q116 86 116 82 L116 18 Q116 14 112 14 L44 14 Q40 14 38 10 L36 6 Q34 4 30 4 Z";
const FOLDER_FRONT_PATH = "M4 22 Q4 18 8 18 L112 18 Q116 18 116 22 L116 82 Q116 86 112 86 L8 86 Q4 86 4 82 Z";

interface BoardsFanCardProps {
  onClose: () => void;
}

export function BoardsFanCard({ onClose }: BoardsFanCardProps) {
  const { currentBoardId, navigateToBoard, getVisibleBoards } = useCanvasStore();

  // Get recent visible boards sorted by updated_at (most recent first), excluding current board
  const recentBoards = [...getVisibleBoards()]
    .filter(b => b.id !== currentBoardId)
    .sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime())
    .slice(0, 5);
  
  const handleBoardClick = (board: Board) => {
    navigateToBoard(board);
    onClose();
  };

  return (
    <div className="w-56 bg-background/95 backdrop-blur-sm rounded-xl shadow-lg border border-border p-2 animate-fade-in">
      {/* Header */}
      <div className="px-2 py-1.5 text-xs font-medium text-muted-foreground uppercase tracking-wide">
        Recent Boards
      </div>
      
      {/* Board list */}
      <div className="space-y-0.5">
        {recentBoards.length === 0 ? (
          <div className="px-3 py-4 text-sm text-muted-foreground text-center">
            No other boards yet
          </div>
        ) : (
          recentBoards.map(board => {
            const colorPalette = getFolderColorFromValue(board.icon_color);
            return (
              <button
                key={board.id}
                onClick={() => handleBoardClick(board)}
                className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-left hover:bg-muted transition-colors"
              >
                {/* Mini folder icon */}
                <div className="w-8 h-6 relative shrink-0">
                  <svg viewBox="0 0 120 90" className="w-full h-full">
                    <path
                      d={FOLDER_PATH}
                      fill={colorPalette.folderDark}
                    />
                    <path
                      d={FOLDER_FRONT_PATH}
                      fill={colorPalette.folder}
                    />
                  </svg>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground truncate">
                    {board.name}
                  </div>
                </div>
              </button>
            );
          })
        )}
      </div>
      
    </div>
  );
}
